class FiltersGroup extends HTMLElement {
  constructor() {
    super();

    const type = this.dataset.filtersGroup 

    if (type == 'size') {
      this.filterInputs = this.querySelectorAll('[data-size]');
      this.filterLabels = this.querySelectorAll('[data-size-label]');
      this.sizes = [];

      this.bindDuplicates();
      this.hideDuplicates();
      this.reorder();
    }
  }

  bindDuplicates() {
    this.filterInputs.forEach((input) => {
      input.addEventListener('change', this.handleChange.bind(this));
    })
  }

  reorder() {
    this.sizes.sort((a, b) => {
      return b - a;
    });

    this.sizes.forEach((size) => {
      const labels = this.querySelectorAll(`[data-size-label="${size}"]`);

      this.prepend(...labels);
    });
  }

  hideDuplicates() {
    this.filterLabels.forEach((label) => {
      const size = parseInt(label.dataset.sizeLabel, 10);

      if (this.sizes.includes(size)) {
        label.classList.add('visually-hidden');
      } else {
        this.sizes.push(size);
      }
    });
  }

  handleChange(event) {
    const size = event.target.dataset.size;
    const matchingSizes = this.querySelectorAll(`[data-size="${size}"]`);
    
    matchingSizes.forEach((input) => {
      input.checked = event.target.checked;
    })
  }
}

customElements.define("filters-group", FiltersGroup);


class FiltersCta extends HTMLElement {
  constructor() {
    super();

    this.bindEvents();
  }

  bindEvents() {
    const applyButton = this.querySelector('button.apply');
    applyButton.addEventListener('click', this.onApplyButtonClick);

    const clearButton = this.querySelector('button.clear');
    clearButton.addEventListener('click', this.onClearButtonClick);
  }

  onApplyButtonClick() {
    const innerWidth = window.innerWidth;

    // if(innerWidth < 1024) {
      const filterLabel = document.querySelector('.collection__nav-inner .collection__filters-label');
      filterLabel.click();
    // }
    // else {
    //   location.reload();
    // }
  }

  onClearButtonClick() {
    const hash = window.location.hash;
    const sortString = hash.split('/').filter((item) => {
      return item.includes('sort:')
    })

    let newUrl; 
    if( sortString.length ) {
      newUrl = window.location.href.split('#')[0] + "#/" + sortString[0];
    
    }
    else {
      newUrl = window.location.href.split('#')[0];
    }

    window.location.href = newUrl;
  }
}

customElements.define("filters-cta", FiltersCta);

